import React from 'react';
import { ProductCardProps } from './ProductCard.types';
import { ProductCardShowcase } from './ProductCardShowcase';

export const ProductCard: React.FC<ProductCardProps> = (props) => {
  const { variant = 'showcase' } = props;
  if (variant === 'showcase') return <ProductCardShowcase {...props} />;

  return null;
};
